import React, { useCallback } from "react";
import { Drawer, Spin } from "antd";
import { DrawerProps } from "antd/lib/drawer";
import ReviewDrawerHeader from "./components/ReviewDrawerHeader";
import ReviewDrawerFooter from "./components/ReviewDrawerFooter";
import styles from "./index.module.scss";
import { QuestionBlock } from "./components/QuestionBlock";
import useRequest from "utils/useRequest";
import { ExamPaperItem, getStudentExamPaperInfo } from "service/exam";
import { toNumber } from "service/service";
import CustomEmpty from "../../../../../../../components/CourseComponents/CustomEmpty";
import StuPhotos from "./components/StuPhotos";

interface ReviewDrawerProps extends DrawerProps {
    afterClose?: () => void;
    onCancel?: () => void;
    goPrev?: () => void;
    goNext?: () => void;
    batchNo: string;
    paperData?: ExamPaperItem;
}

export default function ReviewDrawer({
    afterClose,
    onCancel,
    goPrev,
    goNext,
    batchNo,
    paperData,
    ...props
}: ReviewDrawerProps) {
    const [data, { loading }] = useRequest(
        () =>
            getStudentExamPaperInfo({
                paperId: paperData?.paperId || "",
                studentId: paperData?.studentId || "",
                batchNo
            }),
        {},
        [paperData, batchNo]
    );

    const afterVisibleChange = useCallback(
        (visible: boolean) => {
            if (!visible) afterClose?.();
        },
        [afterClose]
    );

    return (
        <Drawer
            className={styles.root}
            placement="right"
            width={800}
            {...props}
            onClose={onCancel}
            afterVisibleChange={afterVisibleChange}>
            <ReviewDrawerHeader
                studentName={paperData?.name}
                studentNo={paperData?.studentNo}
                paperName={data?.paperName}
                endTime={data?.endTime}
            />

            <Spin
                className={styles.body}
                wrapperClassName={styles.body}
                spinning={loading}>
                <div>
                    {data?.topics.map(item => (
                        <QuestionBlock key={item.topicId} data={item} />
                    ))}

                    {data?.uploadFiles && <StuPhotos data={data.uploadFiles} />}
                </div>

                {!loading && !data && (
                    <CustomEmpty description="该考生未交卷" />
                )}
            </Spin>

            <ReviewDrawerFooter
                score={toNumber(data?.score)}
                goPrev={goPrev}
                goNext={goNext}
            />
        </Drawer>
    );
}
